import type { AsignacionImpuestoCliente } from '@/services/clientesService'
import type { ImpuestoLiquidar } from './clienteSchema'

/**
 * Builds the initial tax list of the edit form.
 * The active rows of `impuestos_cliente` decide which taxes are in the list, with their catalog code.
 * Each item keeps the other fields of the `impuestos_liquidar` JSONB item with the same `impuesto_id`, such as `notas`.
 * Without table rows, it returns the JSONB list unchanged.
 */
export function impuestosIniciales(
  asignaciones: AsignacionImpuestoCliente[] | undefined,
  impuestosJsonb: ImpuestoLiquidar[] | null | undefined
): ImpuestoLiquidar[] {
  const jsonb = impuestosJsonb ?? []
  if (!asignaciones) return jsonb

  const jsonbPorId = new Map(jsonb.map((item) => [item.impuesto_id, item]))
  return asignaciones
    .filter((asignacion) => asignacion.activo)
    .map((asignacion) => {
      const previo = jsonbPorId.get(asignacion.impuesto_id)
      return {
        ...previo,
        impuesto_id: asignacion.impuesto_id,
        codigo: asignacion.impuesto?.codigo ?? previo?.codigo ?? '',
      }
    })
}
